import type { Variants, Transition } from 'framer-motion';

type BezierEase = [number, number, number, number];

/** Premium ease — low bounce, Stripe-like */
export const ease: BezierEase = [0.22, 1, 0.36, 1];

// ─── Core variants (transform + opacity only) ─────────────────────────────────

export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 18 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.52, ease } as Transition },
};

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.45, ease } as Transition },
};

export const scaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.97, y: 8 },
  visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.52, ease } as Transition },
};

export const slideLeft: Variants = {
  hidden: { opacity: 0, x: -20 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.52, ease } as Transition },
};

export const slideRight: Variants = {
  hidden: { opacity: 0, x: 20 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.52, ease } as Transition },
};

/** Alias — no blur (GPU-safe) */
export const blurUp: Variants = fadeUp;

export const fadeUpGpu = fadeUp;

// ─── Stagger containers (tighter to avoid animation stacking) ─────────────────

export const staggerFast: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.05, delayChildren: 0.02 } },
};

export const staggerMed: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.07, delayChildren: 0.04 } },
};

export const staggerSlow: Variants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.09, delayChildren: 0.06 } },
};

// ─── Viewport — once, lazy margin reduces scroll-time work ────────────────────

export const viewport = { once: true, margin: '-10% 0px' } as const;
export const viewportLazy = { once: true, margin: '-14% 0px' } as const;

// ─── Hover (transform only) ─────────────────────────────────────────────────────

export const cardHoverY = {
  y: -4,
  transition: { duration: 0.28, ease } as Transition,
} as const;

export const subtleHover = {
  scale: 1.01,
  transition: { duration: 0.24, ease } as Transition,
} as const;

/** Prefer CSS transitions over spring layout animations */
export const springTransition: Transition = { type: 'tween', duration: 0.32, ease };
